import {
    HeadSectionContent,
    SectionsTitleText,
} from "../../models/common/common";
import colors from "../../styles/colors.module.scss";

const headTitle: SectionsTitleText[] = [
    {
        text: "Find every answer here",
        color: colors.textWhiteLight,
        fontWeight: "fw-bold",
        newLine: true,
    },
];

const headSubTitle: SectionsTitleText[] = [
    {
        text: "",
        color: colors.textWhiteLight,
        fontWeight: "fw-bold",
        newLine: false,
    },
];

export const headData: HeadSectionContent = {
    backgroundImageUrl:
        "https://images.unsplash.com/photo-1633613286848-e6f43bbafb8d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    title: headTitle,
    subTitle: headSubTitle,
};

export const faqListTitle: SectionsTitleText[] = [
    {
        text: "Frequently",
        color: colors.textPrimary,
        fontWeight: "fw-bold",
        newLine: false,
    },
    {
        text: "Asked Questions",
        color: colors.textBlack,
        fontWeight: "fw-bold",
        newLine: false,
    },
];

export const faqListSubTitle: SectionsTitleText[] = [
    {
        text: "We created a set of Frequently Asked Questions to satisfy any of your curiosities or doubts.",
        color: colors.textBlackThree,
        fontWeight: "",
        newLine: true,
    },
    {
        text: "We hope we’ve been helpful!",
        color: colors.textBlackThree,
        fontWeight: "",
        newLine: false,
    },
];
